module.exports = __webpack_public_path__ + "img/1_nydj.53d62e81.jpg";